<template>
    <div v-show="isActive">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'tab',
    data() {
        return {
            isActive: false
        };
    },
    props: {
        name: { required: true },
        selected: { default: false}
    },
    computed: {
        href() {
            return '#' + this.name.toLowerCase().replace(/ /g, '-');
        }
    },
    mounted() {
        this.isActive = this.selected;
    }
}
</script>


// WEBPACK FOOTER //
// src/components/widge/Tab.vue